// extracted by mini-css-extract-plugin
export default {"Button":"Button_Button__9xuar","buttonDisabled":"Button_buttonDisabled__8fm4M"};